export enum PlayerSize {
    SMALL,
    LARGE
}
